(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
function loadProductRecommendationsIntoSection(productRecommendationsSection) {
  if (!productRecommendationsSection || !productRecommendationsSection.dataset.url) return;
  if (productRecommendationsSection.dataset.loading === 'true') return;

  productRecommendationsSection.dataset.loading = 'true';

  fetch(productRecommendationsSection.dataset.url)
    .then(function(response) {
      if (!response.ok) throw new Error('Unable to load product recommendations');
      return response.text();
    })
    .then(function(html) {
      var container = document.createElement('div');
      container.innerHTML = html;

      var recommendations = container.querySelector('.related-products');
      if (recommendations) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(function() {
      productRecommendationsSection.removeAttribute('data-loading');
    });
}

function loadAllProductRecommendationSections(root) {
  root.querySelectorAll('.related-products[data-section-id][data-url]').forEach(function(section) {
    loadProductRecommendationsIntoSection(section);
  });
}

document.addEventListener('shopify:section:load', function(event) {
  loadAllProductRecommendationSections(event.target);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    loadAllProductRecommendationSections(document);
  });
} else {
  loadAllProductRecommendationSections(document);
}

  } catch(e) { console.error(e); }
})();
})();
